var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "container-fluid bg-secondary border-0 mb-0 shadow-none projectGantt",
    },
    [
      _c("div", { staticClass: "row no-gutters border row--overflow" }, [
        _c(
          "div",
          {
            staticClass: "bg-white col-md-12 col-sm-12 border-right col-mod",
            class: { "pt-3": _vm.editMode },
          },
          [
            _c(
              "div",
              { staticClass: "table-responsive table-responsive--mod" },
              [
                _c(
                  "table",
                  { staticClass: "table align-items-center table-flush" },
                  [
                    _vm._m(0),
                    _vm.archivedTasks
                      ? _c(
                          "tbody",
                          { staticClass: "list overflow-auto" },
                          _vm._l(_vm.archivedTasks, function (task, ind) {
                            return _c(
                              "tr",
                              {
                                key: ind,
                                staticClass: "editable",
                                class: { active: true },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("taskClick", task)
                                  },
                                },
                              },
                              [
                                _c("td", { attrs: { scope: "row" } }, [
                                  _c("div", { staticClass: "media-body" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "gantt_task_line gantt_bar_task position-relative sm-gantt_task_line",
                                        staticStyle: {
                                          height: "45px",
                                          "line-height": "45px",
                                          width: "100%",
                                          "background-color": "gray",
                                        },
                                      },
                                      [
                                        _vm._m(1, true),
                                        _c("div", {
                                          staticClass: "gantt_task_content",
                                          domProps: {
                                            innerHTML: _vm._s(task.name),
                                          },
                                        }),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "thead-light" }, [
      _c("tr", [
        _c(
          "th",
          {
            staticClass: "py-0",
            staticStyle: { "min-width": "500px", height: "27px" },
            attrs: { scope: "col" },
          },
          [_vm._v("\n                Archived Projects\n              ")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "gantt_task_progress_wrapper" }, [
      _c("div", {
        staticClass: "gantt_task_progress",
        staticStyle: { width: "0px" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }